import { useInstantSearch } from 'react-instantsearch';
import Image from "./../../../assets/images/icons/hand.png";

const SuggestionInput = ({ hideNoResultDiv }: any) => {
    function NoResultsBoundary({ children, fallback }: any) {
        const { results } = useInstantSearch();

        // The `__isArtificial` flag makes sure not to display the No Results message
        // when no hits have been returned.
        if (!results.__isArtificial && results.nbHits === 0) {
            return (
                <>
                    {fallback}
                    <div hidden>{children}</div>
                </>
            );
        }

        return children;
    }

    //The UI for when search result is not found
    function NoResults() {
        const { indexUiState } = useInstantSearch();

        return (
            <div ref={hideNoResultDiv} style={{ display: "block" }}>
                <div className="no__result_section">
                    <div className="content__wrapper">
                        <img src={Image} alt="suggest_image" height={25} loading="lazy" />
                        <em>
                            <p>Suggest a new product&nbsp;<strong>{indexUiState.query}</strong></p>
                        </em>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <NoResultsBoundary fallback={<NoResults />} />
    )
}

export default SuggestionInput